import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleConfig,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
  provideSoftAppsModuleConfig,
  provideSoftAppsModuleInfo,
} from '@softapps/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { isDefinedNotEmpty, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import {
  ArbeitsscheinConfig,
  SOFTLINE_CONFIG_ARBEITSSCHEIN,
} from './arbeitsschein.config';
import { workNoteRoutes } from './arbeitsschein.routes';
import { SOFTLINE_PERMISSION_WORK_NOTE } from './arbeitsschein.shared';

export const arbeitsscheinProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'arbeitsschein',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#WORK_NOTE.TITLE',
      icon: 'fa-regular fa-note-sticky',
      route: '/arbeitsschein',
      permission: SOFTLINE_PERMISSION_WORK_NOTE,
      color: 'bg-warning text-black',
      group: getModuleGroupByName('Gewerbe'),
    });
  }),
  provideSoftAppsModuleInfo('#WORK_NOTE.TITLE', {
    library: '@softapps/gewerbe/arbeitsschein',
    description: 'Arbeitsscheine erfassen, unterschreiben und abschließen.',
  }),
  provideSoftAppsModuleConfig('#WORK_NOTE.TITLE', SOFTLINE_CONFIG_ARBEITSSCHEIN),
];

export function provideWorkNoteModule(config?: ArbeitsscheinConfig) {
  const providers = [
    ...provideSoftAppsModule(
      {
        name: 'gewerbe_work-note',
        title: '#WORK_NOTE.TITLE',
        icon: 'fa-regular fa-note-sticky',
        route: '/arbeitsschein',
        permission: SOFTLINE_PERMISSION_WORK_NOTE,
        color: 'bg-warning text-black',
        group: getModuleGroupByName('Gewerbe'),
      },
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleRoutes({
        app: workNoteRoutes(config),
      }),
      withSoftAppsModuleConfig(SOFTLINE_CONFIG_ARBEITSSCHEIN),
      withSoftAppsModuleInfo({
        library: '@softapps/gewerbe/arbeitsschein',
        description: 'Arbeitsscheine erfassen, unterschreiben und abschließen.',
      })
    ),
  ];

  if (isDefinedNotEmpty(config)) {
    providers.push({
      provide: SOFTLINE_CONFIG_ARBEITSSCHEIN,
      useValue: config,
    });
  }

  return providers;
}
